<button
  mat-menu-item
  [matTooltip]="'Download as PNG'"
  [matTooltipPosition]="'before'"
  [matMenuTriggerFor]="savePngOptionsMenu"
  [intercomTarget]="'download-png'"
>
  <fa-icon [icon]="['fal', 'file-image']" class="text-[16px] mr-2"></fa-icon>
  Download as PNG
</button>

<mat-menu #savePngOptionsMenu="matMenu" [overlapTrigger]="false" [backdropClass]="toolbarBackdropClass">
  <button mat-menu-item (click)="downloadPng.emit(exportMode.Viewport)">
    <fa-icon [icon]="['fal', 'frame']" class="text-[16px] mr-2"></fa-icon>
    Current view
  </button>
  <button mat-menu-item (click)="downloadPng.emit(exportMode.Diagram)">
    <fa-icon [icon]="['fal', 'expand']" class="text-[16px] mr-2"></fa-icon>
    Full diagram
  </button>
</mat-menu>
